export enum DesignCard {
  None = 'NONE',
  Cover = 'COVER',
  Theme = 'THEME',
}
